import Link from 'next/link';
import cn from 'classnames';
import settings from '@/settings';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const ProductWarrantyDisclaimer = ({ className }: { className?: string }) => {
  if (settings.store === 'reebelo-ca') {
    return (
      <div
        className={cn(
          'text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        <div>
          A service fee will apply once your claim has been approved{' '}
          <Link
            href="https://edge.reebelo.com/files/sqt/PDS-CA.pdf"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            T&C Applies
          </Link>{' '}
          /{' '}
          <Link
            href="https://edge.reebelo.com/files/sqt/PDS-FRCA.pdf"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            T&C s'appliquent
          </Link>
        </div>
        <div className="mt-1">
          Notice for Quebec residents:{' '}
          <Link
            href="https://edge.reebelo.com/files/sqt/IWI-CA.pdf"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Important Warranty Information / Avis important sur la garantie
            légale
          </Link>
        </div>
      </div>
    );
  }

  if (settings.store === 'reebelo-au' || settings.store === 'reebelo-dev') {
    return (
      <div
        className={cn(
          'text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        *Please read the{' '}
        <a
          href="https://edge.reebelo.com/files/rmg/rc.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://edge.reebelo.com/files/rmg/tmd.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Target Market Determination
        </a>{' '}
        for details, including how this plan works alongside your ACL rights.
      </div>
    );
  }

  if (settings.store === 'reebelo-nz') {
    return (
      <div
        className={cn(
          'text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        This plan is issued by Renewable Mobile NZ Limited (NZBN:
        9429050657926). By purchasing, you confirm you have read and agree to
        the
        <a
          href="https://edge.reebelo.com/files/rmg/rc-nz.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms & Conditions.
        </a>
      </div>
    );
  }

  if (settings.store === 'reebelo-us') {
    return (
      <div
        className={cn(
          'text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        {t`By purchasing ReebeloCare you agree to the`}{' '}
        <Link href="/policies/warranty-and-refund-policy" className="underline">
          {t`terms and condition`}
        </Link>
      </div>
    );
  }

  return null;
};

export default ProductWarrantyDisclaimer;
